import { useLanguage } from "@/context/LanguageContext";
import { useLocation } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { TripEnquiryForm } from "@/components/TripEnquiryForm";
import { useEnquiry } from "@/context/EnquiryContext";

export const QuoteModal = () => {
  const { t } = useLanguage();
  const { open, prefill, setOpen } = useEnquiry();
  const location = useLocation();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="quote-modal">
        <DialogHeader>
          <DialogTitle className="text-2xl font-extrabold text-slate-900">{t("Request a Quote")}</DialogTitle>
          <DialogDescription className="text-slate-600">
            {t("Share your trip details — we'll call you back with a fare and vehicle. Required fields are marked with an asterisk.")}
          </DialogDescription>
        </DialogHeader>
        <TripEnquiryForm prefill={prefill} sourcePage={`modal:${location.pathname}`} />
      </DialogContent>
    </Dialog>
  );
};
